import React from 'react';
import { Checkbox } from '@nextiva/next-ui-components';

const MemoCheckbox = React.memo(
  ({ checkBoxStateHelper, checkBoxValue, checkBoxField, fieldType, id }) => {
    return (
      <Checkbox
        id={id}
        width={20}
        {...checkBoxStateHelper(checkBoxValue, checkBoxField, fieldType)}
      />
    );
  },
);

export default MemoCheckbox;
